import {PlatformNavbarMenuItem} from "@flexinet/ui-components";
import {
    AiOutlineAppstore,
    AiOutlineHome
} from 'react-icons/ai'

import {IconContext} from "react-icons";
import {RbacAction} from '../../../config/rbac/actions.ts';

// FNP-1935: ids are fixed and readable so an entry is addressable across
// renders, and rbac is an RbacAction so a misspelt action fails to compile.
export type MarketplaceMenuItem = PlatformNavbarMenuItem & {
    id: `nav-${string}`,
    rbac: RbacAction,
};

// FNP-1960: Registrations, Offers and Metering Records left with the AWS-shaped API.
export const getMenuItems = (): MarketplaceMenuItem[] => {

    return [
        {
            id: 'nav-dashboard',
            link: '/dashboard',
            label: 'Dashboard',
            icon: <IconContext.Provider value={{size: '2em'}}><AiOutlineHome/></IconContext.Provider>,
            rbac: 'ViewDashboard',
        },
        {
            id: 'nav-products',
            link: '/products',
            label: 'Products',
            icon: <IconContext.Provider value={{size: '2em'}}><AiOutlineAppstore/></IconContext.Provider>,
            rbac: 'ListProducts',
        }];

};
